var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "pc-share-wrapper"
  }, [_c("div", {
    staticClass: "share-content"
  }, [_c("div", {
    ref: "shareContentRef",
    staticStyle: {
      background: "linear-gradient(#f8efff, #e0f4ff)"
    }
  }, [_c("div", {
    staticClass: "share-header"
  }, [_c("van-image", {
    attrs: {
      src: _vm.logoUrl,
      height: "48px",
      width: "180px"
    }
  })], 1), _c("div", {
    staticClass: "share-body"
  }, [_c("div", {
    staticClass: "question-box-wrapper"
  }, [_c("div", {
    staticClass: "question-box",
    domProps: {
      innerHTML: _vm._s(_vm.renderMessage(_vm.question.content))
    }
  })]), _c("div", {
    staticClass: "answer-box m-t-16",
    domProps: {
      innerHTML: _vm._s(_vm.renderMarkDown(_vm.answer.content))
    }
  }), _vm.isOverFlow ? _c("van-image", {
    staticClass: "overflow-backdrop-filter",
    attrs: {
      src: _vm.filterBase64
    }
  }) : _vm._e()], 1), _c("div", {
    staticClass: "share-footer"
  }, [_c("van-image", {
    attrs: {
      src: _vm.footerUrl
    }
  }), _c("div", {
    staticClass: "share-qrcode"
  }, [_vm.qrCodeBase64 ? _c("van-image", {
    attrs: {
      src: _vm.qrCodeBase64
    }
  }) : _vm._e()], 1)], 1)])]), _c("div", {
    staticClass: "share-button-group"
  }, [_c("div", {
    staticClass: "share-button",
    on: {
      click: _vm.generateImageUploadToServer
    }
  }, [_c("svg-icon", {
    attrs: {
      name: "share-download",
      size: "48"
    }
  }), _c("span", [_vm._v("存为图片")])], 1), _c("div", {
    staticClass: "share-button",
    on: {
      click: _vm.copyLinkHandler
    }
  }, [_c("svg-icon", {
    attrs: {
      name: "share-link",
      size: "48"
    }
  }), _c("span", [_vm._v("复制链接")])], 1)])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };